import { create, StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { SquareState } from './types';
import { initialState } from './initialState';
import {
  createFetchSquares,
  createClaimSquare,
  createAssignSquare,
  createLabelSquare,
  createClearSquare,
} from './actions';

const createSquareStore: StateCreator<SquareState, [['zustand/devtools', never]]> = (set, get) => ({
  ...initialState,

  fetchSquares: createFetchSquares(set),
  claimSquare: createClaimSquare(get),
  assignSquare: createAssignSquare(get),
  labelSquare: createLabelSquare(get),
  clearSquare: createClearSquare(get),

  clearError: () => {
    set({ error: null });
  },

  reset: () => {
    set(initialState);
  },
});

export const useSquareStore = create<SquareState>()(
  devtools(createSquareStore, { name: 'square-store' })
);

// Re-export types and selectors
export type { SquareState } from './types';
export {
  selectSquares,
  selectGrid,
  selectSquareAt,
  selectClaimedSquares,
  selectClaimedCount,
  selectAvailableCount,
  selectUserClaimedCount,
  selectOfflinePlayerClaimedCount,
} from './selectors';
